import { useState } from 'react';
import { FaFlag } from 'react-icons/fa6';
import { outlineButtonStyles, solidButtonStyles } from '~/styles/buttonStyles';

const priorityOptions = [
    { label: 'High Priority', value: 'high', color: '#F02D3A' },
    { label: 'Medium Priority', value: 'medium', color: '#FEBF3E' },
    { label: 'Low Priority', value: 'low', color: '#AFC12D' },
];
const ApReviewModal = ({
    modalOpen,
    setModalOpen,
    handleApReviewSubmit,
}: {
    modalOpen: boolean;
    setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
    handleApReviewSubmit: (priority: string) => void;
}) => {
    const [selectedPriority, setSelectedPriority] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const handlePriorityChange = (value: string) => {
        setSelectedPriority(value);
    };

    const handleSubmit = async () => {
        try {
            setIsSubmitting(true);
            await handleApReviewSubmit(selectedPriority);
            setIsSubmitting(false);
            setModalOpen(false);
        } catch (error) {
            setIsSubmitting(false);
        }
    };

    return (
        <>
            {modalOpen && (
                <div
                    className='fixed inset-0 z-[99999] flex items-center justify-center bg-black bg-opacity-75'
                    onClick={() => setModalOpen(false)}
                >
                    <div
                        onClick={(e) => e.stopPropagation()}
                        className='relative w-full max-w-xl rounded-lg bg-white shadow-lg'
                    >
                        <div className='p-7'>
                            <h2 className='mb-4 text-3xl font-semibold'>
                                Set Priority for Review
                            </h2>

                            <p>
                                Please select the priority level for this
                                request for AP Review. All requests will be
                                reviewed but those that need immediate attention
                                should be tagged as "High".
                            </p>
                            <div className='mb-4 mt-7'>
                                {priorityOptions.map((priority) => (
                                    <div
                                        key={priority.value}
                                        className='mt-[12px]'
                                    >
                                        <div className='align-center flex gap-[12px]'>
                                            <input
                                                id={`td-${priority.value}`}
                                                type='radio'
                                                value={priority.value}
                                                checked={
                                                    selectedPriority ===
                                                    priority.value
                                                }
                                                onChange={() =>
                                                    handlePriorityChange(
                                                        priority.value
                                                    )
                                                }
                                                className='mt-[2px] h-[18px] w-[18px]'
                                            />
                                            <label
                                                htmlFor={`td-${priority.value}`}
                                            >
                                                {priority.label}
                                            </label>
                                            <FaFlag
                                                color={priority.color}
                                                className='mt-1'
                                            />
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div className='flex gap-[16px]'>
                                <button
                                    onClick={() => setModalOpen(false)}
                                    type='button'
                                    className={outlineButtonStyles}
                                    disabled={isSubmitting}
                                >
                                    Cancel
                                </button>
                                <button
                                    type='button'
                                    className={`${solidButtonStyles()}`}
                                    onClick={handleSubmit}
                                    disabled={isSubmitting}
                                >
                                    {isSubmitting
                                        ? 'Saving...'
                                        : 'Set Priority'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default ApReviewModal;
